export default __webpack_public_path__ + "static/media/ImageWebDev.487a39c3.svg";